// 面试结构v3 -子结构
import Model from "../../model";
import { QuestionV2 } from "@/lib/model/exambuilder/question-v2";
import { Message } from "element-ui";
import { Check } from "@/lib/enum/check";

//多选选项
export class MutiChoiceOption extends Model {
  key = ""; // 选项内容
  desc = ""; // 选项描述
  type = ""; // 类型 unsetOthers 与其他选项互斥
  showDesc = false; //前端用
}
//二级单选
export class Choice2Option extends Model {
  keyList1: string[] = [""]; //一级选项
  keyList2: string[][] = [["", ""]]; //二级选项
  keyList1Chk: string[] = [""]; //复刻一下数据 表单校验用
  keyList2Chk: string[][] = [["", ""]];
}

//条件展示
export class ShowConfig extends Model {
  matchParamId = 0; //父级id 后台
  matchParamIndex = 0; //父级id (为前端新建时)
  matchType = "equal"; //父级类型 多选contains 日期dateToAgeRange
  matchValue = ""; //命中值
  fId = ""; //父字段选项id
}

export class Param extends Model {
  paramId = 0; // 登记信息id 创建场景0修改场景非0
  paramIndex = 0; //总排序

  name = ""; // 登记信息名 姓名/手机 必填
  isShow = 0; // 是否使用 1是
  isRequired = 2; // 是否必填 1是
  inputType = ""; // 输入类型 姓名->string 手机->phone
  singleChoiceOptions = [""]; // choice -> 单择选项
  fIdList = [""]; //单选选项唯一标识list
  mutiChoiceOptions: MutiChoiceOption[] = [new MutiChoiceOption()]; //多选选项
  choice2options = new Choice2Option(); //二级选项

  sort = 0; //已选排序 候选人答题端的排序 ASC 尽量互不相等 相等按paramId排序
  parentParamId = 0; // 级联登记信息-父节点id 修改场景优先id
  parentParamIndex = 0; // 级联登记信息-父节点在列表中的index 从1记 新建场景使用
  parentParamChoiceIndex = [1]; // 级联登记信息-父节点选项index 从1记 取值[1,len()]

  showConfigList: ShowConfig[][] = [[new ShowConfig()]]; //条件展示
  isHeaderOption = false; //是否由考察项转化而来的
  saveLater = 0; //后台用 1为登记后
  imageUrl = ""; //题目配图
  dateConfig = {
    dateFormat: 0,
    daysLimit: 0
  };
  interviewTimeConfig = {
    daysLimit: 3,
    timesLimit: [["09:00", "18:00"]]
  };
}

export class BasicQuality extends Model {
  dimensionKey = ""; // 维度键
  dimensionName = ""; // 维度名(冗余)
  questionIdList: number[] = [0]; // 题目id列表
  questionList: QuestionV2[] = [new QuestionV2()]; // 题目信息列表(冗余)
  score = 0; // 维度配分(非自定义客观题维度)
  sort = 0; // 答题时排序
  name = "";
  active = false;

  initSort = 0; // 前端字段，初始化排序

  get isCustom() {
    return this.dimensionKey === "自定义客观题";
  }

  get questions() {
    return this.questionList.filter(item => item.questionId);
  }

  // 答题用时计算逻辑：视频题每道5分钟，选择填空每道1分钟
  get testingTime() {
    return this.questions.reduce((pre, item) => {
      const questionTime =
        item.getQuestionTypeText() === "视频题" ? 5 * 60 : 60;
      return pre + questionTime;
    }, 0);
  }
}
export class ObjectiveQuestionScore extends Model {
  questionId = 0; // 自定义客观题题目id
  score = 0; // 自定义客观题题目配分
}
export class IseEnglish extends Model {
  use = 0; // 是否使用(冗余/题目id列表为空表示不使用)
  questionIdList: number[] = [0]; // 题目id列表
  questionList: QuestionV2[] = [new QuestionV2()]; // 题目信息列表(冗余)
  score = 0; // 维度配分
  sort = 0; // 答题时排序
  name = "英语口语测试"; // 名字
  active = false;

  get questions() {
    return this.questionList.filter(item => item.questionId);
  }

  // 答题用时计算逻辑：朗读题每道3分钟，自由说每道5分钟
  get testingTime() {
    if (this.use !== 1) return 0;

    return this.questions.reduce(
      (pre, item) => pre + (item.hasReadText === 1 ? 3 * 60 : 5 * 60),
      0
    );
  }

  // 将数组中所有没有意义的new实例刷掉
  getCleanDefaultData() {
    const res: IseEnglish = JSON.parse(JSON.stringify(this));

    if (res.questionList.length === 1 && res.questionList[0].questionId === 0) {
      res.questionList = [];
    }

    if (res.questionIdList.length === 1 && res.questionIdList[0] === 0) {
      res.questionIdList = [];
    }

    return res;
  }

  reset() {
    return new IseEnglish();
  }
}
export class IseChinese extends Model {
  use = 0; // 是否使用(冗余/题目id列表为空表示不使用)
  questionIdList: number[] = [0]; // 题目id列表
  questionList: QuestionV2[] = [new QuestionV2()]; // 题目信息列表(冗余)
  score = 0; // 维度配分
  sort = 0; // 答题时排序
  name = "普通话口语测试";
  active = false;

  get questions() {
    return this.questionList.filter(item => item.questionId);
  }

  // 答题用时计算逻辑：朗读题每道3分钟，自由说每道5分钟
  get testingTime() {
    if (this.use !== 1) return 0;

    return this.questions.reduce(
      (pre, item) => pre + (item.hasReadText === 1 ? 3 * 60 : 5 * 60),
      0
    );
  }

  // 将数组中所有没有意义的new实例刷掉
  getCleanDefaultData() {
    const res: IseChinese = JSON.parse(JSON.stringify(this));

    if (res.questionList.length === 1 && res.questionList[0].questionId === 0) {
      res.questionList = [];
    }

    if (res.questionIdList.length === 1 && res.questionIdList[0] === 0) {
      res.questionIdList = [];
    }

    return res;
  }

  reset() {
    return new IseChinese();
  }
}
export class GameTest extends Model {
  gameTestType = 0; // 游戏类型
  sort = 0; // 答题时排序
  name = "";
}

export class FingerTest extends Model {
  use = 0; // 是否使用(冗余/三个子开关都不使用表示不使用) 012
  flexible = 0; // 灵活度检测
  complete = 0; // 完整度检测
  scar = 0; // 疤痕检测
  sort = 0; // 答题时排序
  name = "手部综合检测";

  get testingCount() {
    const testMap = [this.flexible, this.complete, this.scar];
    return testMap.reduce((pre, item) => {
      return pre + (item === 1 ? 1 : 0);
    }, 0);
  }

  // 手指检测用时计算逻辑：不管检测几项，都需要1分钟
  get testingTime() {
    return this.testingCount > 0 ? 60 : 0;
  }

  reset() {
    return new FingerTest();
  }
}
export class ColorTest extends Model {
  use = 0; // 是否使用(冗余/三个子开关都不使用表示不使用) 开关012
  sort = 0; // 答题时排序
  name = "辨色检测";

  // 辨色检测用时计算逻辑：1分钟
  get testingTime() {
    return this.use === 1 ? 60 : 0;
  }

  reset() {
    return new ColorTest();
  }
}
export class PhysicalInstrument extends Model {
  fingerTest = new FingerTest(); // 手指检测
  colorTest = new ColorTest(); // 色盲检测
}
export class JobMatching extends Model {
  identityInfo = 0; // 背调-身份信息验证三要素 开关012
  socialInfo = 0; // 背调-社会不良信息
  financialRisk = 0; // 背调-金融风险

  get hasBgCheck() {
    return (
      this.identityInfo === 1 ||
      this.socialInfo === 1 ||
      this.financialRisk === 1
    );
  }
}
export class PsyUse extends Model {
  use = 0; // 是否使用(冗余/题目id列表为空表示不使用)
  psycGaugeSubDimensionIdList: number[] = [0]; // 心理量表维度id列表
  sort = 0; // 答题时排序
  name = "";

  // 前端字段
  private _psycGaugeSubDimensionList: {
    id: number;
    questionCount: number;
  }[] = [
    {
      id: 0,
      questionCount: 0
    }
  ];

  get subDimensionIdList() {
    return this.psycGaugeSubDimensionIdList.filter(item => item);
  }

  get psycGaugeSubDimensionList() {
    return this._psycGaugeSubDimensionList.filter(item => item.id !== 0);
  }

  set psycGaugeSubDimensionList(nVal: { id: number; questionCount: number }[]) {
    this._psycGaugeSubDimensionList = nVal;
    this.psycGaugeSubDimensionIdList = nVal.map(item => item.id);
  }

  reset() {
    return new PsyUse();
  }
}
export class PsychologicalMotivation extends Model {
  psyc1 = new PsyUse(); // 大五人格原版
  psyc3 = new PsyUse(); // DISC
  psyc4 = new PsyUse(); // 大五人格简版
  psyc5 = new PsyUse(); // dvf

  get psyc1TestingTime() {
    if (this.psyc1.use !== 1) return 0;

    const itemTotal = this.psyc1.psycGaugeSubDimensionList.reduce(
      (pre, item) => pre + item.questionCount,
      0
    );
    return Math.min(itemTotal * 15, 60 * 60);
  }

  get psyc3TestingTime() {
    return this.psyc3.use === 1 ? 40 * 15 : 0;
  }

  get psyc4TestingTime() {
    if (this.psyc4.use !== 1) return 0;

    const itemTotal = this.psyc4.psycGaugeSubDimensionList.reduce(
      (pre, item) => pre + item.questionCount,
      0
    );
    return Math.min(itemTotal * 15, 15 * 60);
  }

  get psyc5TestingTime() {
    return this.psyc5.use === 1 ? 33 * 15 : 0;
  }
}
export class KnowledgeAndSkills extends Model {
  iseEnglish = new IseEnglish(); // 英语维度
  iseChinese = new IseChinese(); // 普通话维度
  gameTestList: GameTest[] = [new GameTest()]; // 游戏测评id列表

  get gameTests() {
    return this.gameTestList.filter(item => item.gameTestType);
  }

  get gameTestingTime() {
    const itemTotal = this.gameTests.length;
    return itemTotal * 3 * 60;
  }

  // 将数组中所有没有意义的new实例刷掉
  getCleanDefaultData() {
    const res: KnowledgeAndSkills = JSON.parse(JSON.stringify(this));

    if (
      res.gameTestList.length === 1 &&
      res.gameTestList[0].gameTestType === 0
    ) {
      res.gameTestList = [];
    }

    res.iseEnglish = this.iseEnglish.getCleanDefaultData();
    res.iseChinese = this.iseChinese.getCleanDefaultData();

    return res;
  }
}

//**********************   基本信息 第一大步   **********************
export class BasicInformation extends Model {
  name = ""; // 名称
  remark = ""; // 备注
  positionId = 0; // 岗位ID
  positionName = ""; // 岗位名称(冗余)
  templateId = 0; // 模版id(仅创建,禁止修改)
  description = "";
}

//**********************   流程信息 第二大步   **********************
interface QuestionCheckDesc {
  res: boolean;
  activeType?: Check;
  activeItem?: string;
}

export class ProcessInformation extends Model {
  basicQualityList: BasicQuality[] = [new BasicQuality()]; //基础素质列表
  objectiveQuestionScoreList: ObjectiveQuestionScore[] = [
    new ObjectiveQuestionScore()
  ]; // 自定义客观题维度下分数配分列表
  knowledgeAndSkills = new KnowledgeAndSkills(); // 知识与技能
  physicalInstrument = new PhysicalInstrument(); // 体质仪表
  jobMatching = new JobMatching(); // 工作匹配
  psychologicalMotivation = new PsychologicalMotivation(); // 心理动机(预留成可多选结构,当期禁止多选,后续可能会放开)

  // 面试总用时为各项用时加总，并额外预留10分钟
  get allTestingTime() {
    const nlpTestingTime = this.basicQualityList.reduce(
      (pre, item) => pre + item.testingTime,
      0
    );

    const { iseEnglish, iseChinese, gameTestingTime } = this.knowledgeAndSkills;
    const { fingerTest, colorTest } = this.physicalInstrument;
    const {
      psyc1TestingTime,
      psyc3TestingTime,
      psyc4TestingTime,
      psyc5TestingTime
    } = this.psychologicalMotivation;

    const time =
      nlpTestingTime +
      iseEnglish.testingTime +
      iseChinese.testingTime +
      gameTestingTime +
      fingerTest.testingTime +
      colorTest.testingTime +
      psyc1TestingTime +
      psyc3TestingTime +
      psyc4TestingTime +
      psyc5TestingTime;

    return time === 0 ? time : time + 3 * 60;
  }

  // 获取题目总数
  get questionCount() {
    const res = {
      total: 0,
      video: 0
    };

    this.basicQualityList.forEach(item => {
      res.total += item.questions.length;
      res.video += item.questions.filter(
        q => q.getQuestionTypeText() === "视频题"
      ).length;
    });

    res.total += this.knowledgeAndSkills.iseEnglish.questions.length;
    res.video += this.knowledgeAndSkills.iseEnglish.questions.filter(
      q => q.getQuestionTypeText() === "视频题"
    ).length;

    res.total += this.knowledgeAndSkills.iseChinese.questions.length;
    res.video += this.knowledgeAndSkills.iseChinese.questions.filter(
      q => q.getQuestionTypeText() === "视频题"
    ).length;

    return res;
  }

  // 提交前的处理逻辑，将数组中所有没有意义的new实例刷掉
  getCleanDefaultData() {
    const res: ProcessInformation = JSON.parse(JSON.stringify(this));

    if (
      res.basicQualityList.length === 1 &&
      res.basicQualityList[0].dimensionKey === ""
    ) {
      res.basicQualityList = [];
    }

    if (
      res.objectiveQuestionScoreList.length === 1 &&
      res.objectiveQuestionScoreList[0].questionId === 0
    ) {
      res.objectiveQuestionScoreList = [];
    }

    res.knowledgeAndSkills = this.knowledgeAndSkills.getCleanDefaultData();

    return res;
  }

  // 分数配置页面校验
  checkDataByScore(hasToast = true) {
    let totalScore = 0;
    this.basicQualityList.forEach(basic => {
      totalScore += basic.score;
    });
    totalScore += this.knowledgeAndSkills.iseChinese.score;
    totalScore += this.knowledgeAndSkills.iseEnglish.score;
    if (totalScore !== 100) {
      if (hasToast) {
        Message.error("请保持总分为100");
      }
      return false;
    }
    return true;
  }
  // 题目选择校验
  checkDataByQuestion(isDetailRes: true): QuestionCheckDesc;
  checkDataByQuestion(isDetailRes?: false): boolean;
  checkDataByQuestion(isDetailRes = false): boolean | QuestionCheckDesc {
    const { psyc1, psyc4 } = this.psychologicalMotivation;
    const { fingerTest } = this.physicalInstrument;
    const fingerTestItems = [
      fingerTest.flexible,
      fingerTest.complete,
      fingerTest.scar
    ];
    const { iseEnglish, iseChinese } = this.knowledgeAndSkills;
    if (fingerTest.use === 1 && !fingerTestItems.includes(1)) {
      // this.validateFail(Check.FINGER_TEST);
      return isDetailRes
        ? { res: false, activeType: Check.FINGER_TEST }
        : false;
    }

    if (iseEnglish.use === 1 && !iseEnglish.questions.length) {
      return isDetailRes
        ? { res: false, activeType: Check.ENGLISH, activeItem: "英语" }
        : false;
    }

    if (iseChinese.use === 1 && !iseChinese.questions.length) {
      return isDetailRes
        ? { res: false, activeType: Check.CHINESE, activeItem: "普通话" }
        : false;
    }

    if (!this.basicQualityList.length)
      return isDetailRes ? { res: false } : false;

    for (let i = 0; i < this.basicQualityList.length; i++) {
      const item = this.basicQualityList[i];

      if (!item.questions.length) {
        return isDetailRes
          ? {
              res: false,
              activeType: Check.DIMENSION,
              activeItem: item.dimensionKey
            }
          : false;
      }
    }

    if (psyc1.use === 1 && !psyc1.psycGaugeSubDimensionIdList.length) {
      return isDetailRes
        ? { res: false, activeType: Check.BIG_FIVE_240 }
        : false;
    }

    if (psyc4.use === 1 && !psyc4.psycGaugeSubDimensionIdList.length) {
      return isDetailRes
        ? { res: false, activeType: Check.BIG_FIVE_60 }
        : false;
    }

    return isDetailRes ? { res: true } : true;
  }
  // 工具选择check _isAssigned
  checkDataByTool() {
    const list = this.basicQualityList.filter(
      el => el.isAssigned && el.dimensionKey && el.dimensionName
    );
    return list.length >= 1;
  }
}

//**********************   其他设置信息 第三大步   **********************
export class SettingInformation extends Model {
  //时间设置
  timeConfig = {
    examBeginTogether: 2, // 是否统一开考 012
    noEnding: 1, // 是否面试有效期长期有效
    beginTime: "", // 面试开始时间
    endTime: "", // 面试结束时间(非长期有效)
    timeLimitExam: 86400, // 面试时间限制(秒)
    timeLimitHours: 24, // 面试时间限制(小时)(前端冗余) td
    timeLimitMinutes: 0, // 面试时间限制(分钟)（前端冗余） td
    examRegisterEndTime: "" //报名截止时间
  };
  //虚拟视频配置
  virConfig = {
    virVersion: 4 // 虚拟视频版本
    //        VirVersionGuess     VirVersion = 0 // 默认 靠公司配置推算
    // VirVersionTtsXunfei VirVersion = 1 // TTS版 讯飞形象
    // VirVersionTtsTx     VirVersion = 2 // TTS版 腾讯形象
    // VirVersionIvhTx     VirVersion = 3 // IVH版 腾讯形象
    // VirVersionIvhXunfei VirVersion = 4 // IVH版 讯飞形象
  };
  paramList: Param[] = [new Param()]; // 登记信息列表
  captchaCheck = 2; // 是否校验验证码 手机字段 012
  //页面配置
  publicityPage = {
    publicityPageContent:
      "海纳隶属于北京群星闪耀科技有限公司，致力于以AI技术赋能人力资源行业，帮助千千万万人才和企业做好人岗匹配、提升组织效率。拥有雄厚资本支持，可保证团队投入大量资金和人力到产品研发上，持续提升AI及产品能力，为大型集团提供可靠、持久的杰出服务。", // 岗位描述
    publicityPageVideoUrl: "", // 宣传视频链接(自定义视频/默认视频)
    publicityPageVideoCoverUrl: "", // 宣传封面链接(自定义封面/默认封面)
    publicityPageImgUseWhich: 1, // 宣传图片封面使用类型(0:不使用:1默认图片:2:自定义图片)-冗余 td
    publicityPageVideoUseWhich: 0, // 宣传视频使用类型(0:不使用:1默认视频:2:自定义视频)-冗余
    publicityPageVideoAutoplay: 2, // 宣传页视频是否自动播放 012
    descBefore:
      "你好，我是本次面试的面试官，欢迎参加本公司的线上面试！面试预计需要T_I_M_E，请你提前安排在网络良好、光线亮度合适、且相对安静的环境参加这次面试，以免影响本次面试的结果。如果你在面试过程中遇到问题，请与我们的招聘人员联系。", // 面试须知语富文本
    descBeforeShowWay: 0, // 面试须知展示方式(0:虚拟面试官/1:预置背景/2:自定义背景)
    descBeforeShowWayImgUrl: "", // 面试须知自定义背景图片
    descBeforeVideoMustPlay: 2, // 面试须知是否强制播放 012
    descAfter:
      "感谢你参加面试，面试结果我们会在1-3个工作日内通知你。我们期待你的加入，再见！", // 面试结束语富文本
    descAfterShowWay: 0, // 面试结束展示方式(0:虚拟面试官/1:预置背景/2:自定义背景)
    descAfterShowWayImgUrl: "", // 面试结束自定义背景图片
    descAfterShowWayIsSame: 1 // 面试结束展示方式是否和面试须知相同 012
    // descAfterVideoMustPlay: 2 // 面试结束语是否强制播放 012 td
  };
  //防作弊配置
  preventionCheatConfig = {
    screenshotCheck: 2, // 是否开启小程序截屏检测 012
    screenshotCheckLimit: 0, // 小程序截屏检测自动交卷限制次数
    mobileJoinCountCheck: 2, // 是否开启小程序跳出检测 012
    mobileJoinCountCheckLimit: 0, // 小程序跳出检测自动交卷限制次数
    livenessRecognition: 2, // 是否开启身份识别 012
    lrType: 2, // 身份识别实现版本
    //     EnumLrTypeScreenshotWithH5  EnumLrType = 1 // H5证件照+抽帧检测 改变答题入口 不依赖登记信息身份证号
    // EnumLrTypeScreenshotWithStd EnumLrType = 2 // 登记信息身份证号 + 视频题抽帧 aibuilder版本默认
    // EnumLrTypePhoto             EnumLrType = 3 // 登记信息输入身份证号 + 拍证件照 aiworker版本默认
    // EnumLrTypeReadNumber        EnumLrType = 4 // 念数字版 慎用不合规
    // EnumLrTypeSyncPhoto         EnumLrType = 5 // 登记信息输入身份证号 + 拍证件照 + 前端实时检测
    lrRetryNumberLimit: 0, // 人脸识别失败重试次数0表示不允许
    lrErrorAutoSubmit: 1, // 人脸识别失败是否自动交卷(仅lrType=6) 2 不自动交卷，1 自动交卷
    replacePersonCheck: 2, // 是否开启换人检测 012
    faceDetection: 2 // 是否开启露脸检测 012
  };
  //规则配置
  ruleConfig = {
    // repeatAnswer: 1, // 是否允许重复作答012  //小程序用
    isRepeatAnswerLimit: 2, // 是否限制重复面试次数012  //hr端用
    repeatAnswerLimit: -1, // 作答次数限制 默认-1不限制 1不允许重复 >1表示重复次数  //真实限制次数
    removeMaskTip: 2, // 是否开启摘口罩提示 012
    canOpenJoin: 1, // 是否允许公开邀请 012
    isNoCreateOpenJoin: 2 // 公开邀请范围 默认2所有人  1面试邀请候选人
  };
  //体验配置
  experienceConfig = {
    closeQuestionVideo: 2, // 是否关闭题目视频 012
    wxminiDeviceDetection: 2, // 是否需要小程序设备检测 012
    wxminiNoiseDetection: 2, // 是否需要小程序噪声检测 012
    testExamId: 0, // 模拟练习面试id 0为不开启模拟练习
    testExamSwitch: 2 // 是否开启模拟练习 012 td
  };
  // 面试有效期文本
  get interviewValidityPeriod() {
    const { examBeginTogether, noEnding, beginTime, endTime } = this.timeConfig;
    const tipText = "待选择";
    if (examBeginTogether === 2) {
      // 随来随面
      if (noEnding === 1) {
        return "长期有效";
      } else {
        return `${beginTime ? beginTime : tipText} ~ ${
          endTime ? endTime : tipText
        }`;
      }
    } else {
      // 统一面试
      return `${beginTime ? beginTime : tipText} ~ ${
        endTime ? endTime : tipText
      }`;
    }
  }
  // 是否要求了身份证号
  get hasIdCardNum() {
    return this.paramList.some(
      item => item.name === "身份证号" && item.isShow === 1
    );
  }
}

// 面试统计量
export class ExamCount extends Model {
  beforeStart = 0; // 未开始
  afterEnd = 0; // 已结束
  isPlaying = 0; // 进行中
  all = 0; // 全部
}

// 面试列表item
export class ExamItem extends Model {
  examId = 0; // 面试id
  examIdForSetWeb = ""; // 面试批次id
  examVersionId = 0; // 面试最新版本id，通过与面试id对比确定有没有版本
  companyId = 0; // 公司id
  connectCode = ""; // 面试链接码
  name = ""; // 面试名称
  remark = ""; // 备注
  examType = "aibuilder"; // 新版只支持aibuilder
  positionId = 0; // 岗位id
  positionName = ""; // 岗位名称
  noEnding = 0; // 是否长期有效
  beginTime = ""; // 面试开始时间
  endTime = ""; // 面试结束时间
  lastUpdateTime = ""; // 末次更新时间
  questionNumber = 0; // 题目数量
  useTimeSecond = 0; // 预计时长
  examBeginTogether = 0; // 是否是统一开考
  isExamvd = 0; // 是否兼容重构版
  createdTime = ""; // 创建时间
  platformVersion = 0; // 答题设备限制，0-仅小程序，1-仅web，2-小程序+web
  canOpenJoin = 0; // 是否开启了公开邀请
  hasVersion = false; // 目前后端没有版本相关的，不管怎样前端都需要这样一个字段，先默认为true，提测改为false
  isLast = false; // 前端字段，是否是最新版本
  isSubVersion = false; // 前端字段，是否是子版本
  fatherExamId = 0; // 前端字段，父版本id
  isNoCreateOpenJoin = 0;
  dataChange = true;
}
